"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditoExpressProvider = exports.getTokenAutenticacaoFirebase = exports.useCreditoExpress = void 0;
const react_1 = __importStar(require("react"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const estadoInicial_1 = __importDefault(require("./estadoInicial"));
const reducer_1 = __importDefault(require("./reducer"));
const tratativasAutenticacao_1 = __importDefault(require("./tratativasAutenticacao"));
const CeContext = react_1.createContext({
    state: estadoInicial_1.default(),
});
const useCreditoExpress = () => react_1.useContext(CeContext);
exports.useCreditoExpress = useCreditoExpress;
let getTokenAutenticacaoFirebase = async () => '';
exports.getTokenAutenticacaoFirebase = getTokenAutenticacaoFirebase;
const CreditoExpressProvider = ({ children, useFirebase, useAuth, organizacaoWhitelabel, }) => {
    const firebase = useFirebase();
    const [state, dispatch] = react_1.useReducer(reducer_1.default, estadoInicial_1.default(organizacaoWhitelabel));
    const { autenticacaoLoading, usuarioFirebase } = state;
    const { onUsuarioLogin, onLogout } = react_1.useMemo(() => tratativasAutenticacao_1.default(dispatch), [dispatch]);
    const auth = useAuth({
        onUsuarioLogin,
        onLogout,
    });
    const { necessarioAceitarTermos, tokenComErro, signout } = auth;
    react_1.useEffect(() => {
        recuperaUsuarioPreviamenteAutenticado();
        iniciaObserverAtualizaTokenAutenticacaoLocalStorage();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    react_1.useEffect(() => {
        if (necessarioAceitarTermos) {
            dispatch({
                type: 'ATUALIZAR_DADOS_AUTENTICACAO',
                payload: {
                    autenticacaoLoading: false,
                    necessarioAceitarTermos: true,
                },
            });
        }
    }, [necessarioAceitarTermos]);
    react_1.useEffect(() => {
        if (tokenComErro) {
            signout();
        }
    }, [tokenComErro]);
    react_1.useEffect(() => {
        if (usuarioFirebase && Object.keys(usuarioFirebase).length) {
            exports.getTokenAutenticacaoFirebase = async () => {
                const token = await usuarioFirebase.getIdToken(true);
                window.localStorage.setItem('tokenAutenticacao', token);
                return token;
            };
        }
        else {
            exports.getTokenAutenticacaoFirebase();
        }
    }, [usuarioFirebase]);
    const recuperaUsuarioPreviamenteAutenticado = () => {
        const unsubscribe = firebase.auth().onIdTokenChanged(user => {
            if (user) {
                dispatch({
                    type: 'ATUALIZAR_DADOS_AUTENTICACAO',
                    payload: {
                        usuarioFirebase: user,
                    },
                });
                const { recuperarPessoaEOrganizacaoPorUsuario } = auth;
                recuperarPessoaEOrganizacaoPorUsuario(user);
            }
            else {
                unsubscribe();
                dispatch({
                    type: 'ATUALIZAR_DADOS_AUTENTICACAO',
                    payload: {
                        autenticacaoLoading: false,
                    },
                });
            }
        });
    };
    const iniciaObserverAtualizaTokenAutenticacaoLocalStorage = () => {
        firebase.auth().onIdTokenChanged(async (user) => {
            if (user) {
                const idToken = await user.getIdToken();
                window.localStorage.setItem('tokenAutenticacao', idToken);
            }
            else {
                window.localStorage.removeItem('tokenAutenticacao');
            }
        });
    };
    if (autenticacaoLoading) {
        return react_1.default.createElement(CircularProgress_1.default, { disableShrink: true, style: { color: '#969696' } });
    }
    return (react_1.default.createElement(CeContext.Provider, { value: { state, dispatch } }, children));
};
exports.CreditoExpressProvider = CreditoExpressProvider;
//# sourceMappingURL=index.js.map